import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const DirectFarmerInvoiceForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const chequeRef = useRef({});
  const [chequeDetails, setChequeDetails] = useState([]);
  const [chequeClose, setChequeClose] = useState(false);

  const bankTransferRef = useRef({});
  const [bankTransferDetails, setBankTransferDetails] = useState([]);
  const [bankTransferClose, setBankTransferClose] = useState(false);
  const [directFarmerInvoiceId, setDirectFarmerInvoiceId] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const [procurementRecieptId, setprocurementRecieptId] = useState();
  const [ProcurementRecieptData, setProcurementRecieptData] = useState([]);
  const [procRecieptProductdata, setprocRecieptProductdata] = useState([]);
  const [totalProcAmount, settotalProcAmount] = useState(null);
  const [currencyCode, setCurrencyCode] = useState(
    localStorage.getItem("currencyCode")
  );

  const [loading, setLoading] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [serviceId, setServiceId] = useState(0);
  useEffect(() => {
    console.log("props", props.sId);

    setServiceId(props.sId);
  }, []);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: getGatePass } = useHttp();
  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getprocurementReciept } = useHttp();
  useEffect(() => {
    getprocurementReciept(
      {
        url: `/api/ProcurementRecieptForInvoice/`,
      },
      (res) => {
        if (res) {
          //console.log("procurementRecieptData", res);
          setProcurementRecieptData(res);
        }
      }
    );
  }, [getprocurementReciept]);

  const { sendRequest: gatePass } = useHttp();

  const { sendRequest: getprocurmentData } = useHttp();

  const loadprocurmentData = (id) => {
    setprocurementRecieptId(id);
    frmRef.current.balanceAmount.value = "0";
    frmRef.current.totalAmount.value = "0";
    frmRef.current.advanceAmount.value = "0";
    frmRef.current.getpassNo.value = "";
    frmRef.current.loadQuantity.value = "";
    frmRef.current.farmerName.value = "";

    getprocurmentData(
      {
        url: `/api/procurementProductReciept/?procurementRecieptId=${id}`,
      },
      (res) => {
        console.log("procRecieptProductdata", res.ProcurementReciept);
        setprocRecieptProductdata(res.ProcurementReciept);

        var itemlist = ProcurementRecieptData.filter(
          (item) => parseInt(item.procurementRecieptId) == parseInt(id)
        );

        //console.log("itemlist", itemlist);

        frmRef.current.loadQuantity.value =
          itemlist[0].loadQuantity + " " + itemlist[0].unitAbbreviation;
        frmRef.current.farmerName.value = itemlist[0].farmerName;

        var gatepassId = itemlist[0].gatepassId;

        frmRef.current.getpassNo.value = itemlist[0].getpassNo;
        gatePass(
          {
            url: `/api/gatePass/?gatepassId=${gatepassId}`,
          },
          (res) => {
            if (res) {
              //console.log("gatePass", res[0]);
              frmRef.current.contactnumber.value = res.contactnumber;
            }
          }
        );
      }
    );
  };

  const setCash = () => {
    if (frmRef.current.cash.checked) {
      frmRef.current.bank_transfer.disabled = true;
      frmRef.current.cheque.disabled = true;
      frmRef.current.cheque.checked = false;
      frmRef.current.bank_transfer.checked = false;
    } else {
      frmRef.current.bank_transfer.disabled = false;
      frmRef.current.cheque.disabled = false;
    }
  };
  // const { sendRequest: getpassIdProc } = useHttp();
  // const [gatepassId, setGatePassId] = useState();

  // useEffect(() => {
  //   getpassIdProc(
  //     {
  //       url: `/api/gatePass/?orgId=${localStorage.getItem("orgId")}&proc=true`,
  //     },
  //     (data) => {
  //       setGatePassId(data);
  //     }
  //   );
  // }, [getpassIdProc]);

  const { sendRequest: postDirectInvoice } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    if (procRecieptProductdata.length == 0) {
      toast.error("Please enter at least one product!");
      return;
    } else {
      var itemlist = procRecieptProductdata.filter(
        (item) => parseFloat(item.rate || 0) == 0
      );

      if (itemlist.length > 0) {
        toast.error("Please enter rate of the product!");
        setClose(true);
        return;
      }
    }

    if (frmRef.current.cheque.checked) {
      if (chequeDetails.length == 0) {
        toast.error("Please enter at cheque details!");
        setChequeClose(true);
        return;
      }
    }
    if (frmRef.current.bank_transfer.checked) {
      if (bankTransferDetails.length == 0) {
        toast.error("Please enter at bank transfer details!");
        setBankTransferClose(true);
        return;
      }
    }

    if (
      frmRef.current.cash.checked == false &&
      frmRef.current.cheque.checked == false &&
      frmRef.current.bank_transfer.checked == false
    ) {
      toast.error("Please select one payment option!");
      return;
    }

    var paymentmode = "Cash";
    var paymentDetail = "";
    if (frmRef.current.cheque.checked) {
      paymentmode = "Cheque";
      paymentDetail = chequeDetails;
    }
    if (frmRef.current.bank_transfer.checked) {
      paymentmode = "Bank Transfer";
      paymentDetail = bankTransferDetails;
    }
    setLoading(true);

    //console.log("Submit data");
    const data = {
      invoiceDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      procurementRecieptId: procurementRecieptId,
      supervisorEmployeeId: assignEmployeeId,
      warehouseId: localStorage.getItem("warehouseId"),
      paymentmode: paymentmode,
      paymentDetail: paymentDetail,
      productDetails: procRecieptProductdata,
      totalAmount: frmRef.current.totalAmount.value.trim(),
      advanceAmount: frmRef.current.advanceAmount.value.trim(),
      balanceAmount: frmRef.current.balanceAmount.value.trim(),
      pendingBalanceAmount: frmRef.current.balanceAmount.value.trim(),
      remark: frmRef.current.remark.value.trim(),
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };
    
    postDirectInvoice(
      {
        url: "/api/directFarmerInvoice/",
        method: directFarmerInvoiceId ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Farmer invoice added`);
        props.addForm(false);
        setLoading(false);
      },(error) => {
       
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

 
  const submitBankTransferDetails = (e) => {
    e.preventDefault();

    if (bankTransferRef.current.acc_holder_name.value.trim() == "") {
      toast.error("Please enter account number!");
      return;
    } else if (bankTransferRef.current.account_number.value.trim() == "") {
      toast.error("Please enter account holder name!");
      return;
    } else if (bankTransferRef.current.ifsc_code.value.trim() == "") {
      toast.error("Please enter IFSC code!");
      return;
    } else {
      setBankTransferDetails((x) => [
        ...x,
        {
          srno:
            bankTransferDetails.length > 0
              ? bankTransferDetails[bankTransferDetails.length - 1].srno + 1
              : 1,

          accountNumber: bankTransferRef.current.account_number.value.trim(),
          accountHolderName:
            bankTransferRef.current.acc_holder_name.value.trim(),
          ifscCode: bankTransferRef.current.ifsc_code.value.trim(),
        },
      ]);

      //console.log(bankTransferDetails);
    }
  };
  const handleDeleteBank = (index, e) => {
    setBankTransferDetails(bankTransferDetails.filter((v, i) => i !== index));
  };
  // bank details
  const submitChequeDetails = (e) => {
    e.preventDefault();
    if (chequeRef.current.cheque_bank_name.value.trim() == "") {
      toast.error("Please enter at cheque cheque bank name!");
      return;
    } else if (chequeRef.current.cheque_number.value.trim() == "") {
      toast.error("Please enter at cheque number!");
      return;
    } else if (
      chequeRef.current.checque_bank_account_number.value.trim() == ""
    ) {
      toast.error("Please enter at cheque bank account number!");
      return;
    } else {
      setChequeDetails((x) => [
        ...x,
        {
          srno:
            chequeDetails.length > 0
              ? chequeDetails[chequeDetails.length - 1].srno + 1
              : 1,

          ChequeBankName: chequeRef.current.cheque_bank_name.value.trim(),
          ChequeNumber: chequeRef.current.cheque_number.value.trim(),
          ChequeBankAccountNumber:
            chequeRef.current.checque_bank_account_number.value.trim(),
        },
      ]);
    }

    //console.log(chequeDetails);
  };
  const handleDeleteCheque = (index, e) => {
    setChequeDetails(chequeDetails.filter((v, i) => i !== index));
  };
  const handlePaymentMode = () => {
    if (frmRef.current.cheque.checked == true) {
      setChequeClose(true);
      setChequeDetails((items) => items.filter((x) => x.isSave));
    }
    if (frmRef.current.bank_transfer.checked == true) {
      setBankTransferClose(true);
      setBankTransferDetails((items) => items.filter((x) => x.isSave));
    }
  };

  return (
    <>
      {/* bank modal Start */}
      {bankTransferClose && (
        <Modal isOpen={bankTransferClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Bank Transfer Account Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setBankTransferClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label htmlFor={"account_number"}>Account Number</label>
                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankTransferRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"acc_holder_name"}>Acount Holder Name</label>
                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) =>
                    (bankTransferRef.current["acc_holder_name"] = el)
                  }
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>
                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankTransferRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <br />
                <button
                  className="btn  btn-secondary mx-2 my-2"
                  onClick={submitBankTransferDetails}
                >
                  +
                </button>
              </div>
            </div>

            <hr />

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                {bankTransferDetails &&
                  bankTransferDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="text-center">
              <div className="">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    bankTransferDetails.map((x) => (x["isSave"] = true));
                    setBankTransferClose(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* bank modal end */}

      {/* cheque modal */}

      {chequeClose && (
        <Modal isOpen={chequeClose} style={customModalStyles}>
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Cheque Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setChequeClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label htmlFor={"cheque_bank_name"}>Cheque Bank Name</label>
                <input
                  type={"input"}
                  id={"cheque_bank_name"}
                  required
                  ref={(el) => (chequeRef.current["cheque_bank_name"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"cheque_number"}>Cheque Number</label>
                <input
                  type={"input"}
                  id={"cheque_number"}
                  required
                  ref={(el) => (chequeRef.current["cheque_number"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"checque_bank_account_number"}>
                  Cheque Bank Account No
                </label>
                <input
                  type={"input"}
                  id={"checque_bank_account_number"}
                  required
                  ref={(el) =>
                    (chequeRef.current["checque_bank_account_number"] = el)
                  }
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <br />
                <button
                  className="btn  btn-secondary mx-2 my-2"
                  onClick={submitChequeDetails}
                >
                  +
                </button>
              </div>
            </div>

            <hr />

            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Cheque Bank Name</th>
                  <th>Cheque Number</th>
                  <th>Cheque Bank Account No</th>
                </tr>
              </thead>
              <tbody>
                {chequeDetails &&
                  chequeDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.srno}</td>
                        <td>{itm.ChequeBankName}</td>
                        <td>{itm.ChequeNumber}</td>
                        <td>{itm.ChequeBankAccountNumber}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDeleteCheque(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <div className="row">
              <div className="col-md-4"> </div>
              <div className="col-md-1"> </div>
              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    chequeDetails.map((x) => (x["isSave"] = true));
                    setChequeClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-2"> </div>
              <div className="col-md-4"> </div>
            </div>
          </div>
        </Modal>
      )}

      {/* cheque modal end */}

      {/* Product modal end */}

      {close && (
        <Modal isOpen={close} style={customModalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Product Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setClose(false)}
                >
                  <i className="fas fa-times" />
                </button>

                <hr />
                <div style={{ float: "right" }}>
                  <label>Note:All values are in {currencyCode}*</label>
                </div>
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Crop Name </th>
                    <th>Variety Name</th>
                    <th>Grade</th>
                    <th>Item</th>
                    <th> Quantity</th>
                    <th>Unit</th>
                    <th>Rate</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {procRecieptProductdata &&
                    procRecieptProductdata.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.cropName}</td>
                          {/* <td>{itm.itemDescription}</td> */}
                          <td>{itm.varietyName}</td>
                          <td>{itm.gradeName}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                          <td>
                            <input
                              type={"text"}
                              id={"procurementQuantity"}
                              required
                              ref={(el) =>
                                (frmRef.current["procurementQuantity"] = el)
                              }
                              className="form-control"
                              defaultValue={procRecieptProductdata[i].rate}
                              onChange={(e) => {
                                procRecieptProductdata[i].rate = e.target.value;
                                procRecieptProductdata[i].lineAmount =
                                  parseFloat(e.target.value || 0) *
                                  parseFloat(itm.itemQuantity);

                                setprocRecieptProductdata([
                                  ...procRecieptProductdata,
                                ]);
                              }}
                            />
                          </td>

                          <td>{procRecieptProductdata[i].lineAmount}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <div className="text-center">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    var i = 0;
                    var totalAmount = 0;

                    //console.log(
                    //   "procRecieptProductdata",
                    //   procRecieptProductdata
                    // );
                    do {
                      totalAmount =
                        totalAmount +
                        parseFloat(
                          procRecieptProductdata &&
                            procRecieptProductdata[i].lineAmount
                        );

                      i++;
                    } while (procRecieptProductdata.length > i);
                    settotalProcAmount(totalAmount);
                    frmRef.current.totalAmount.value = totalAmount;

                    if (frmRef.current.advanceAmount.value != "") {
                      frmRef.current.balanceAmount.value =
                        parseFloat(totalAmount) -
                        parseFloat(frmRef.current.advanceAmount.value);
                    }

                    productDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Direct Farmer Invoice Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee"}
                      </label>
                      <select
                        id="emp_id"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"procurementRecieptId"}>
                        {"Procurement Reciept No"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        required
                        ref={(el) =>
                          (frmRef.current["procurementRecieptId"] = el)
                        }
                        value={procurementRecieptId}
                        onChange={(e) => {
                          setprocurementRecieptId(e.target.value);
                          loadprocurmentData(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          --Select Procurement Reciept No--
                        </option>
                        {ProcurementRecieptData &&
                          ProcurementRecieptData.map((x) => (
                            <option
                              key={x.procurementRecieptId}
                              procurementReciept-id={x.procurementRecieptId}
                              value={x.procurementRecieptId}
                            >
                              {x.procurementRecieptNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"farmer_name"}> {"Farmer Name"}</label>
                      <input
                        type={"text"}
                        id={"farmerName"}
                        readOnly
                        ref={(el) => (frmRef.current["farmerName"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"gate_pass_id"}>{"Gate Pass No"}</label>
                      <input
                        type={"text"}
                        id={"farmer_name"}
                        readOnly
                        ref={(el) => (frmRef.current["getpassNo"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"contactnumber"}
                        readOnly
                        ref={(el) => (frmRef.current["contactnumber"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                      <div style={{ float: "right" }}>
                        <label>Note:All values are in {currencyCode}*</label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>

                      <br />
                      <button
                        type={"button"}
                        id={"Product_details"}
                        onClick={(e) => {
                          e.preventDefault(false);
                          setProductDetails((items) =>
                            items.filter((x) => x.isSave)
                          );
                          setClose(true);
                        }}
                        className="btn btn-sm btn-secondary mx-2 my-2"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"loadQuantity"}>{"Load Quantity"}</label>
                      <input
                        type={"text"}
                        id={"loadQuantity"}
                        readOnly
                        ref={(el) => (frmRef.current["loadQuantity"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"totalAmount"}> {"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"totalAmount"}
                        readOnly
                        ref={(el) => (frmRef.current["totalAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"advanceAmount"}>
                        {" "}
                        {"Advance Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"advanceAmount"}
                        required
                        onChange={(e) => {
                          frmRef.current.balanceAmount.value = totalProcAmount;
                          if (e.target.value != "") {
                            //console.log(parseFloat(totalProcAmount));
                            frmRef.current.balanceAmount.value =
                              parseFloat(totalProcAmount) -
                              parseFloat(e.target.value);
                          }
                        }}
                        ref={(el) => (frmRef.current["advanceAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"balanceAmount"}>
                        {" "}
                        {"Balance Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"balanceAmount"}
                        readOnly
                        ref={(el) => (frmRef.current["balanceAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <label>Farmer Payment Mode</label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input-group mx-3">
                        <label> Cash</label> <br />
                        <input
                          type={"checkbox"}
                          id={"cash"}
                          ref={(el) => (frmRef.current["cash"] = el)}
                          className="form-check-input"
                          name="payment_mode"
                          onClick={setCash}
                        />{" "}
                      </div>

                      <div className="input-group mx-3">
                        <label> cheque</label> <br />
                        <input
                          type={"checkbox"}
                          id={"cheque"}
                          name="payment_mode"
                          ref={(el) => (frmRef.current["cheque"] = el)}
                          className="form-check-input"
                          onClick={handlePaymentMode}
                        />
                      </div>

                      <div className="input-group mx-3">
                        <label> Bank Transfer</label> <br />
                        <input
                          type={"checkbox"}
                          id={"bank_transfer"}
                          name="payment_mode"
                          ref={(el) => (frmRef.current["bank_transfer"] = el)}
                          className="form-check-input"
                          onClick={handlePaymentMode}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
           
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DirectFarmerInvoiceForm;
